import { Script } from "@/model/Script.model";

export const ScriptStore: Script[] = [
  {
    name: "chat_en_US",
    src: "https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js"
  },
  {
    name: "chat_vi_VN",
    src: "https://connect.facebook.net/vi_VN/sdk/xfbml.customerchat.js"
  },
  {
    name: "render_Button_GG",
    src: "https://apis.google.com/js/platform.js?onload=renderButton"
  },
  { name: "google_api_client", src: "https://apis.google.com/js/api:client.js" }
];

export const MetaStore: Script[] = [
  {
    name: "google-signin-client_id",
    content:
      "841652630064-v7f6mop14hkpepjnsin616n8sdn9lhcn.apps.googleusercontent.com"
  }
];

class ScriptService {
  public scripts: any = {};
  public metas: any = {};
  constructor() {
    ScriptStore.forEach(script => {
      this.scripts[script.name] = {
        loaded: false,
        src: script.src
      };
    });
    MetaStore.forEach(meta => {
      this.metas[meta.name] = {
        loaded: false,
        content: meta.content
      };
    });
  }

  loadMultiScript(...scripts: string[]) {
    const promises: any[] = [];
    scripts.forEach(script => promises.push(this.loadScript(script)));
    return Promise.all(promises);
  }

  loadScript(name: string, async?: boolean, defer?: boolean) {
    return new Promise((resolve, reject) => {
      if (this.scripts[name].loaded) {
        resolve({ script: name, loaded: true, status: "Already Loaded" });
      } else {
        const script = document.createElement("script");
        script.async = async || false;
        script.defer = defer || false;
        script.type = "text/javascript";
        script.src = this.scripts[name].src;
        script.onload = () => {
          this.scripts[name].loaded = true;
          resolve({ script: name, loaded: true, status: "Loaded" });
        };
        script.onerror = (err: any) => {
          reject({ script: name, loaded: false, status: "Loaded", error: err });
        };
        document.getElementsByTagName("head")[0].appendChild(script);
      }
    });
  }

  loadMeta(name: string) {
    return new Promise((resolve, reject) => {
      if (this.metas[name].loaded) {
        resolve({ meta: name, loaded: true, status: "Already Loaded" });
      } else {
        const meta = document.createElement("meta");
        meta.name = name;
        meta.content = this.metas[name].content;
        meta.onload = () => {
          this.metas.loaded = true;
          resolve({ meta: name, loaded: true, status: "Loaded" });
        };
        meta.onerror = (err: any) => {
          reject({ meta: name, loaded: false, status: "Loaded", error: err });
        };
        document.getElementsByTagName("head")[0].appendChild(meta);
      }
    });
  }
}

export default new ScriptService();
